"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.UserDeviceAlarm = exports.GetDeviceAlarmsParams = exports.UpdateDeviceRegistryPayload = exports.DeviceRegistryInfo = exports.INTERNAL_DEVICE_FIELDS = exports.GetAiChatSessionsParams = exports.SendMessageResponse = exports.UnexpectedTroubleshootingAgentResponse = exports.MessageDeliveryFailure = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Geography = __importStar(require("../../../../geography"));
const Device = __importStar(require("../../../device"));
const MessageProtocol = __importStar(require("../../../protocol"));
const Protocol = __importStar(require("../protocol"));
const authorization_1 = require("./authorization");
const Error = __importStar(require("./error"));
const Tenant = __importStar(require("./tenant"));
const tracing_1 = require("./tracing");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Device';
const idParam = platform_1.HttpApiSchema.param('id', Device.Class.Common.Id);
const chatIdParam = platform_1.HttpApiSchema.param('chatId', effect_1.Schema.UUID);
const DeviceNotFoundError = Error.NotFoundErrorFromProtocol.annotations({
    description: 'The device could not be found',
});
class MessageDeliveryFailure extends effect_1.Schema.TaggedError(`${exports.NAMESPACE}.MessageDeliveryFailure`)('MessageDeliveryFailure', {
    message: effect_1.Schema.String,
    reason: effect_1.Schema.Literal('DeviceNotFound', 'DeviceNotConnected', 'DeviceUnreachable', 'MessageRejectedByDevice'),
}) {
}
exports.MessageDeliveryFailure = MessageDeliveryFailure;
const MessageDeliveryFailureFromProtocol = Error.ErrorFromProtocol(MessageDeliveryFailure).annotations({
    title: 'Message Delivery Failure',
    description: 'The message could not be delivered for some reason',
    [platform_1.HttpApiSchema.AnnotationStatus]: 502,
});
class UnexpectedTroubleshootingAgentResponse extends effect_1.Schema.TaggedError(`${exports.NAMESPACE}.UnexpectedTroubleshootingAgentResponse`)('UnexpectedTroubleshootingAgentResponse', {
    message: effect_1.Schema.String,
}) {
}
exports.UnexpectedTroubleshootingAgentResponse = UnexpectedTroubleshootingAgentResponse;
const UnexpectedTroubleshootingAgentResponseFromProtocol = Error.ErrorFromProtocol(UnexpectedTroubleshootingAgentResponse).annotations({
    title: 'Unexpected Troubleshooting Agent Response',
    description: 'The troubleshooting agent server sent an unexpected response',
    [platform_1.HttpApiSchema.AnnotationStatus]: 502,
});
exports.SendMessageResponse = effect_1.Schema.Struct({
    status: effect_1.Schema.Literal('Queued', 'Success', 'Unknown'),
    message: effect_1.Schema.String,
    // Set only on a Queued reply, as on the V1 command routes' 202.
    reason: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    queueId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    pendingCount: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.SendMessageResponse`,
    title: 'Send Message Response',
});
const sendMessage = platform_1.HttpApiEndpoint.post('sendMessage') `/${idParam}/message`
    .middleware(Tenant.Middleware)
    .setPayload(MessageProtocol.CloudToDeviceEnvelope)
    .addSuccess(Protocol.responseBodySuccess(exports.SendMessageResponse), { status: 200 })
    .addError(DeviceNotFoundError)
    .addError(MessageDeliveryFailureFromProtocol)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Send Message')
    .annotate(platform_1.OpenApi.Description, 'Send a message to a device');
const AiChatSessionResponseBody = platform_1.HttpApiSchema.withEncoding(effect_1.Schema.String.annotations({
    title: 'Event Stream',
    description: 'An Event Stream. ' +
        'See the Troubleshooting Chat Event schema for details on how events are encoded',
}), {
    kind: 'Text',
    contentType: 'text/event-stream',
}).annotations({
    title: 'AiChatSessionResponseBody',
});
const AiChatSessionRequestHeaders = effect_1.Schema.Struct({
    'last-event-id': effect_1.Schema.optional(effect_1.Schema.String),
}).annotations({
    title: 'AiChatSessionRequestHeaders',
});
const getAiChatSession = platform_1.HttpApiEndpoint.get('getAiChatSession') `/${idParam}/ai/chats/${chatIdParam}`
    .middleware(Tenant.Middleware)
    .setHeaders(AiChatSessionRequestHeaders)
    .addSuccess(AiChatSessionResponseBody, { status: 200 })
    .addError(DeviceNotFoundError)
    .annotate(platform_1.OpenApi.Title, 'Get AI Troubleshooting Chat')
    .annotate(platform_1.OpenApi.Description, 'Get a troubleshooting chat via a realtime event stream. ' +
    'See the Troubleshooting Chat Event schema for details on how events are encoded.')
    // Custom override to document the response schema
    // See https://github.com/Effect-TS/effect/issues/6048
    .annotate(platform_1.OpenApi.Transform, spec => ({
    ...spec,
    responses: {
        ...spec['responses'],
        200: {
            ...spec['responses']?.[200],
            content: {
                ...spec['responses']?.[200]?.['content'],
                'text/event-stream': {
                    ...spec['responses']?.[200]?.['content']?.['text/event-stream'],
                    itemSchema: {
                        $ref: `#/components/schemas/${Device.TroubleshootingChat.NAMESPACE}.Event`,
                    },
                },
            },
        },
    },
}));
const sendAiChatMessage = platform_1.HttpApiEndpoint.post('sendAiChatMessage') `/${idParam}/ai/chats/${chatIdParam}/messages`
    .middleware(Tenant.Middleware)
    .setPayload(Device.TroubleshootingChat.Question.omit('_tag'))
    .addSuccess(Protocol.ResponseBodyEmpty, { status: 201 })
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(DeviceNotFoundError)
    .addError(Error.InternalServerErrorFromProtocol)
    .addError(UnexpectedTroubleshootingAgentResponseFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Send AI Troubleshooting Message')
    .annotate(platform_1.OpenApi.Description, 'Send a message to the AI for troubleshooting a problem in the device. ' +
    'If the UUID used for the chat corresponds to an already existing chat, ' +
    'then the new message is appended, otherwise, a new chat session is ' +
    'created automatically.');
/**
 * Largest page `GET /v2/device/{id}/ai/chats` will serve (IOTPE-1423).
 *
 * Equal to the existing default, which is the only value any caller has
 * asked for. Declaring it turns an unbounded parameter into a stated one
 * without changing what a current caller receives.
 */
const MAX_AI_CHAT_SESSIONS = 100;
exports.GetAiChatSessionsParams = effect_1.Schema.Struct({
    days: effect_1.Schema.optionalWith(effect_1.Schema.NumberFromString.pipe(effect_1.Schema.positive(), effect_1.Schema.int()), {
        exact: true,
        default: () => 30,
    }),
    limit: effect_1.Schema.optionalWith(effect_1.Schema.NumberFromString.pipe(effect_1.Schema.positive(), effect_1.Schema.int(), effect_1.Schema.lessThanOrEqualTo(MAX_AI_CHAT_SESSIONS)), {
        exact: true,
        default: () => MAX_AI_CHAT_SESSIONS,
    }),
}).annotations({
    identifier: 'Culligan.Api.V2.Spec.Device.GetAiChatSessionsParams',
    title: 'Get AI Chat Sessions Params',
});
const getAiChatSessions = platform_1.HttpApiEndpoint.get('getAiChatSessions') `/${idParam}/ai/chats`
    .middleware(Tenant.Middleware)
    .setUrlParams(exports.GetAiChatSessionsParams)
    .addSuccess(Protocol.responseBodySuccess(effect_1.Schema.Array(Device.TroubleshootingChat.Metadata)), {
    status: 200,
})
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(DeviceNotFoundError)
    .addError(Error.InternalServerErrorFromProtocol)
    .addError(UnexpectedTroubleshootingAgentResponseFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Get Troubleshooting Chat Sessions')
    .annotate(platform_1.OpenApi.Description, 'Get a list of (recent) troubleshooting chat sessions represented by their metadata');
const DeviceSerialNumberParams = effect_1.Schema.Struct({
    serialNumber: Device.Class.Common.Id,
}).annotations({
    identifier: 'Culligan.Api.V2.Spec.Device.DeviceSerialNumberParams',
    title: 'Device Serial Number Params',
});
// Internal, dealer, and routing fields that a device owner has no business
// reading. Dropped from the user-facing registry response; every other device
// field (including per-model `prefs`) is preserved. `connectionStatus` is
// dropped here and re-added below without its internal IoT Hub name.
exports.INTERNAL_DEVICE_FIELDS = [
    'connectionStatus',
    'dealer',
    'businessUnit',
    'tenantId',
    'contactInfo',
    'dataRegions',
    'region',
    'loyaltyPrograms',
    'ring',
];
// Connection status kept for the owner, minus the internal IoT Hub name.
const PublicConnectionStatus = Device.Class.Base.ConnectionStatus.pipe(effect_1.Schema.omit('hub')).annotations({
    identifier: 'Culligan.Api.V2.Spec.Device.PublicConnectionStatus',
});
const PublicConnection = effect_1.Schema.Struct({ connectionStatus: PublicConnectionStatus });
exports.DeviceRegistryInfo = effect_1.Schema.Union(effect_1.Schema.Struct(Device.Class.Blackbox.Blackbox.fields).pipe(effect_1.Schema.omit(...exports.INTERNAL_DEVICE_FIELDS), effect_1.Schema.extend(PublicConnection)), effect_1.Schema.Struct(Device.Class.Gbfc.Gbfc.fields).pipe(effect_1.Schema.omit(...exports.INTERNAL_DEVICE_FIELDS), effect_1.Schema.extend(PublicConnection)), effect_1.Schema.Struct(Device.Class.HydroTapBridge.HydroTapBridge.fields).pipe(effect_1.Schema.omit(...exports.INTERNAL_DEVICE_FIELDS), effect_1.Schema.extend(PublicConnection)), effect_1.Schema.Struct(Device.Class.Pelican2.Pelican2.fields).pipe(effect_1.Schema.omit(...exports.INTERNAL_DEVICE_FIELDS), effect_1.Schema.extend(PublicConnection)), effect_1.Schema.Struct(Device.Class.SyncRo.SyncRo.fields).pipe(effect_1.Schema.omit(...exports.INTERNAL_DEVICE_FIELDS), effect_1.Schema.extend(PublicConnection))).annotations({
    identifier: 'Culligan.Api.V2.Spec.Device.DeviceRegistryInfo',
    description: 'A device as returned to its owner, without internal dealer, tenant, contact, and routing fields',
});
const getDeviceRegistryInfo = platform_1.HttpApiEndpoint.get('getDeviceRegistryInfo') `/registry`
    .middleware(Tenant.Middleware)
    .setUrlParams(DeviceSerialNumberParams)
    .addSuccess(Protocol.responseBodySuccess(exports.DeviceRegistryInfo), { status: 200 })
    .addError(DeviceNotFoundError)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Get Device Registry Info')
    .annotate(platform_1.OpenApi.Description, 'Get information about a device from the registry');
const DeviceRegistryInstallationAddress = effect_1.Schema.Struct({
    address: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    zip: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    city: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    state: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    country: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    countryCode: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Geography.CountryCodeIso3166Alpha3), { exact: true }),
    addressExtra: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
}).annotations({
    identifier: 'Culligan.Api.V2.Spec.Device.DeviceRegistryInstallationAddress',
});
const DeviceRegistryContactInfo = effect_1.Schema.Struct({
    phoneNumber: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    email: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    name: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    customerAccountId: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
}).annotations({
    identifier: 'Culligan.Api.V2.Spec.Device.DeviceRegistryContactInfo',
});
exports.UpdateDeviceRegistryPayload = effect_1.Schema.Struct({
    serialNumber: Device.Class.Common.Id,
    installationAddress: effect_1.Schema.optionalWith(DeviceRegistryInstallationAddress, { exact: true }),
    providedLocation: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Geography.NonEmptyGeoPosition), { exact: true }),
    contactInfo: effect_1.Schema.optionalWith(DeviceRegistryContactInfo, { exact: true }),
}).annotations({
    identifier: 'Culligan.Api.V2.Spec.Device.UpdateDeviceRegistryPayload',
    title: 'Update Device Registry Payload',
});
const updateDeviceRegistry = platform_1.HttpApiEndpoint.patch('updateDeviceRegistry') `/registry`
    .middleware(Tenant.Middleware)
    .setPayload(exports.UpdateDeviceRegistryPayload)
    .addSuccess(Protocol.responseBodySuccess(exports.DeviceRegistryInfo), { status: 200 })
    .addError(DeviceNotFoundError)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.NotAuthenticatedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Update Device Registry')
    .annotate(platform_1.OpenApi.Description, 'Claim an existing unowned device or partially update registry details for an owned device. ' +
    'Claim (unowned → owned) rejects SAT (?sat=); field-only updates on an owned device still ' +
    'accept SAT for embeds. Fields listed in INTERNAL_DEVICE_FIELDS (including contactInfo) may be ' +
    'written but are omitted from DeviceRegistryInfo responses on both PATCH and GET.');
const deregisterDevice = platform_1.HttpApiEndpoint.del('deregisterDevice') `/registry`
    .middleware(Tenant.Middleware)
    .setUrlParams(DeviceSerialNumberParams)
    .addSuccess(platform_1.HttpApiSchema.NoContent)
    .addError(DeviceNotFoundError)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.NotAuthenticatedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Deregister Device')
    .annotate(platform_1.OpenApi.Description, 'Deregister a device from the authenticated user. ' +
    'SAT (?sat=) authentication is not accepted on this endpoint; use a bearer SSO session.');
const PositiveIntFromString = effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.positive());
exports.GetDeviceAlarmsParams = effect_1.Schema.Struct({
    serialNumber: Device.Class.Common.Id,
    start: PositiveIntFromString,
    end: PositiveIntFromString,
    page: effect_1.Schema.optionalWith(PositiveIntFromString, { exact: true, default: () => 1 }),
    size: effect_1.Schema.optionalWith(effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.between(1, 100)), {
        exact: true,
        default: () => 20,
    }),
    name: effect_1.Schema.optionalWith(Device.Capability.Alarm.AlarmTag, { exact: true }),
    severity: effect_1.Schema.optionalWith(Device.Capability.Alarm.Severity, { exact: true }),
    status: effect_1.Schema.optionalWith(Device.History.AlarmStatus, { exact: true }),
    search: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyTrimmedString, { exact: true }),
    // Only stored, sortable fields. `severity`/`status` are derived (not stored),
    // and `deviceId` is fixed here, so they are not valid sort keys.
    orderBy: effect_1.Schema.optionalWith(effect_1.Schema.Literal('time', 'name', 'updatedAt', 'dismissedAt'), { exact: true }),
    direction: effect_1.Schema.optionalWith(effect_1.Schema.Literal('asc', 'desc'), { exact: true }),
})
    .pipe(effect_1.Schema.filter(params => {
    if (params.start >= params.end) {
        return { path: ['start'], message: 'start must occur before end' };
    }
    if (params.orderBy && !params.direction) {
        return { path: ['direction'], message: 'direction is required when orderBy is set' };
    }
    if (params.direction && !params.orderBy) {
        return { path: ['orderBy'], message: 'orderBy is required when direction is set' };
    }
    return true;
}))
    .annotations({
    identifier: 'Culligan.Api.V2.Spec.Device.GetDeviceAlarmsParams',
    title: 'Get Device Alarms Params',
});
// A device alarm-history entry as returned to the owner, without the internal
// `dismissedBy` id (the dismisser can be an operator, not the owner).
exports.UserDeviceAlarm = Device.History.Alarm.pipe(effect_1.Schema.omit('dismissedBy')).annotations({
    identifier: 'Culligan.Api.V2.Spec.Device.UserDeviceAlarm',
    description: 'A device alarm-history entry as returned to the device owner',
});
const getDeviceAlarms = platform_1.HttpApiEndpoint.get('getDeviceAlarms') `/alarms`
    .middleware(Tenant.Middleware)
    .setUrlParams(exports.GetDeviceAlarmsParams)
    .addSuccess(Protocol.paginatedResponseBodySuccess(exports.UserDeviceAlarm), { status: 200 })
    .addError(DeviceNotFoundError)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.ValidationErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Get Device Alarms')
    .annotate(platform_1.OpenApi.Description, 'Get the paginated alarm history of a device');
exports.Spec = platform_1.HttpApiGroup.make('device')
    .middleware(authorization_1.UserAuthorization)
    .middleware(tracing_1.Tracing)
    .add(sendMessage)
    .add(getAiChatSession)
    .add(sendAiChatMessage)
    .add(getAiChatSessions)
    .add(getDeviceRegistryInfo)
    .add(updateDeviceRegistry)
    .add(deregisterDevice)
    .add(getDeviceAlarms)
    .prefix('/device')
    .annotate(platform_1.OpenApi.Title, 'Device')
    .annotate(platform_1.OpenApi.Description, 'Device management');
//# sourceMappingURL=device.js.map